import { render, staticRenderFns } from "./RegisterContactItem.vue?vue&type=template&id=17a426ea&scoped=true&"
import script from "./RegisterContactItem.vue?vue&type=script&lang=js&"
export * from "./RegisterContactItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a426ea",
  null
  
)

export default component.exports